// import React, { useEffect, useState } from "react";
// import { Container, Row, Col, Button } from "reactstrap";
// import { useNavigate, useParams } from "react-router-dom";

// import useFetch from "../hooks/useFetch";
// import { BASE_URL } from "../config/config";
// import Helmet from "../components/Helmet";
// import ImageSlider from "../components/Slider";
// import jwtDecode from "jwt-decode";
// import { carBooking, getListingsFeatures, getProfileStatus } from "../util/api";
// import moment from "moment";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

// const CarBookingView = () => {
//   const navigate = useNavigate;
//   const { id } = useParams();
// const [startDate, setStartDate] = useState(moment());
// const [endDate, setEndDate] = useState(moment(startDate).add(2, "day"));
//   const [isLoading, setLoading] = useState(false);
//   const [featuresList, setFeaturesList] = useState([]);

//   const {
//     data: carData,
//     isPending,
//     error,
//   } = useFetch(`${BASE_URL}api/Booking/get-actual-car-detail-by-id?id=${id}`);
//   const {
//     data: carImage,
//     isPendingImage,
//     errorImage,
//   } = useFetch(`${BASE_URL}api/Booking/car-list-photos?carListId=${id}`);

//   console.log(carImage);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     getFeatures();
//   }, [carData]);

// const carReserved = () => {
//   setLoading(true);
//   const token = localStorage.getItem("token");
//   const decode = jwtDecode(token);
//   console.log(decode);
//   getProfileStatus(decode.UserId).then((res) => {
//     console.log(res);
//     if (res.message == "Verified Profile") {
//       const numDays = moment(endDate).diff(moment(startDate), "days");
//       const bookinData = {
//         carListId: carData.carListId,
//         ownerId: carData.ownerId,
//         rentPerDay: carData.price,
//         tripFeePerDay: 0,
//         deliveryFee: 0,
//         tax: 0,
//         totalPrice: carData.price * numDays,
//         tripStartDate: startDate,
//         tripEndDate: endDate,
//         tripdays: numDays,
//         tripPickUpLocation: carData?.pickUpLocation,
//         customerNotes: "string",
//         tripDeliveryLocation: "string",
//         user_Id: "string",
//         activeStatus: true,
//       };
//       carBooking(bookinData).then((res) => {
//         console.log("res", res);
//         if (res.success == true) {
//           alert("Your request is sent to the owner of this car");
//           navigate("/");
//           setLoading(false);
//         }
//       });
//     } else {
//       alert("Your profile is not verified yet");
//       setLoading(false);
//     }
//   });
// };
// function convertMomentToiOSDateString(momentDateString) {
//   const momentFormat = "DD/MM/YYYY hh:mm A";
//   const momentDate = moment(momentDateString, momentFormat);
//   const isoString = momentDate.toISOString();
//   return isoString;
// }
//   const getFeatures = () => {
//     getListingsFeatures(carData.carListId).then((res) => {
//       console.log("fea", res);
//       setFeaturesList(res);
//     });
//   };
//   console.log(startDate);
//   const formatFeatureName = (name) => {
//     // Split the name into words
//     const words = name.split(/(?=[A-Z])/);

//     // Capitalize the first letter of each word
//     const formattedWords = words.map(
//       (word) => word.charAt(0).toUpperCase() + word.slice(1)
//     );

//     // Join the words with spaces in between
//     return formattedWords.join(" ");
//   };

//   const trueFeatures = Object.keys(featuresList[0]).filter(
//     (key) => featuresList[0][key] === true
//   );
//   console.log("true", trueFeatures);
//   return (
//     <Helmet title="Car Booking">
//       <section className="car__booking">
//         <Container>
//           <Row>
//             {isPending && <h6 className="text-center">Loading......</h6>}
//             {carData.length > 0 ? (
//               <h6 className="text-center">{"No Data Found"}</h6>
//             ) : (
//               <>
//                 <Col lg="6">
//                   {/* <img src={carData.carImageUrl} alt="" className="w-100" /> */}
//                   <ImageSlider images={carImage} />
//                 </Col>
//                 <Col lg="6">
//                   <div className="booking__car__info">
//                     <h2> {carData.brandName + " " + carData.carName} </h2>
//                     <h3> {carData.price + "USD Per day"} </h3>
//                     <p className="section__description">
//                       {carData.description}
//                     </p>
//                     <Row>
//                       <div>
// <LocalizationProvider dateAdapter={AdapterDayjs}>
//   <div>
//     <DateTimePicker
//       label="Start Date and Time"
//       // value={startDate}
//       // onChange={(newDate) => setStartDate(newDate)}
//       disableOpenOnFocus={false}
//       onAccept={(newValue) => {
//         const startDate =
//           moment(newValue).format("DD/MM/YYYY hh:mm A");
//         const IOSstringdate =
//           convertMomentToiOSDateString(startDate);
//         console.log("new", IOSstringdate);
//         setStartDate(newValue);
//       }}
//       renderInput={(params) => <input {...params} />} // You can customize the input field here
//     />
//     <DateTimePicker
//       label="End Date and Time"
//       // value={endDate}
//       // onChange={(newDate) => setEndDate(newDate)}
//       onAccept={(newValue) => {
//         const endDate =
//           moment(newValue).format("DD/MM/YYYY hh:mm A");
//         const IOSstringdate =
//           convertMomentToiOSDateString(endDate);
//         console.log("new", IOSstringdate);
//         setEndDate(IOSstringdate);
//       }}
//       renderInput={(params) => <input {...params} />} // You can customize the input field here
//     />
//   </div>
// </LocalizationProvider>
//                       </div>
//                     </Row>
//                   </div>
//                   {/* <div>
//   <h4 style={{ marginTop: 10 }}>Hosted by:</h4>
//   <div>
//     <p>{carData.userName}</p>
//     <p>
//       Joined{moment(carData.joiningDate).format("DD-MM-YYYY")}
//     </p>
//   </div>
// </div> */}
//                   <Button
//                     disabled={isLoading}
//                     onClick={() => carReserved()}
//                     style={{ marginTop: 10 }}
//                   >
//                     Reserve
//                   </Button>
//                 </Col>
//                 <Col>
//                   <h3 style={{ marginTop: 10 }}>Features:</h3>
//                   {trueFeatures.map((feature, index) => (
//                     <li key={index}>{formatFeatureName(feature)}</li>
//                   ))}
//                 </Col>
//               </>
//             )}
//           </Row>
//         </Container>
//       </section>
//     </Helmet>
//   );
// };

// export default CarBookingView;

import React, { useEffect, useState } from "react";
import Helmet from "../components/Helmet";
import {
  Button,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
} from "reactstrap";
import useFetch from "../hooks/useFetch";
import { BASE_URL } from "../config/config";
import { useNavigate, useParams } from "react-router-dom";
import ImageSlider from "../components/Slider";
import {
  carBooking,
  getListingsFeatures,
  getProfileStatus,
  reportListings,
} from "../util/api";
import moment from "moment";
import CarCard from "../components/CarCard";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import FullScreenLoader from "../components/FullScreenLoader";
import jwtDecode from "jwt-decode";
import dayjs from "dayjs";

const CarBookingView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [featuresList, setFeaturesList] = useState([]);
  const [startDate, setStartDate] = useState(moment().toISOString());
  const [pageNumber, setPageNumber] = useState(0);
  const [endDate, setEndDate] = useState(
    moment(startDate).add(2, "day").toISOString()
  );
  const [modal, setModal] = useState(false);
  const [startTimemodal, setStartTimeModal] = useState(false);
  const [endTimeModal, setEndTimeModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reportListingReason, setReportListingReason] = useState("");
  const [reportListingNotes, setReportListingNotes] = useState("");
  const toggle = () => setModal(!modal);
  const toggleStartTime = () => setStartTimeModal(!startTimemodal);
  const toggleEndTime = () => setEndTimeModal(!endTimeModal);
  const {
    data: carData,
    isPending,
    error,
  } = useFetch(`${BASE_URL}api/Booking/get-actual-car-detail-by-id?id=${id}`);
  const {
    data: carImage,
    isPendingImage,
    errorImage,
  } = useFetch(`${BASE_URL}api/Booking/car-list-photos?carListId=${id}`);

  const {
    data: carListingData,
    isPendingListing,
    errorListing,
  } = useFetch(`${BASE_URL}api/Booking/get-listings`);
  useEffect(() => {
    window.scrollTo(0, 0);
    getFeatures();
  }, [carData]);

  const getFeatures = () => {
    getListingsFeatures(carData.carListId).then((res) => {
      if (res.length > 0) {
        const trueFeatures = Object.keys(res[0]).filter(
          (key) => res[0][key] === true
        );
        setFeaturesList(trueFeatures);
      }
    });
  };
  const formatFeatureName = (name) => {
    // Split the name into words
    const words = name.split(/(?=[A-Z])/);
    const formattedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );
    return formattedWords.join(" ");
  };
  const carPerPage = 3;
  const visitedPage = pageNumber * carPerPage;
  const displayPage = carListingData
    .slice(visitedPage, visitedPage + carPerPage)
    .map((item) => <CarCard item={item} />);

  const MyMapComponent = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap
        onClick={(e) => {
          // setlatLng(e.latLng);
        }}
        defaultZoom={8}
        defaultCenter={{
          lat: parseInt(carData.latitude),
          lng: parseInt(carData.longitude),
        }}
      >
        <Marker
          key={carData.id}
          position={{
            lat: parseInt(carData.latitude),
            lng: parseInt(carData.longitude),
          }}
        ></Marker>
      </GoogleMap>
    ))
  );

  const carReserved = () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (token == null) {
      alert("Please Login");
      setLoading(false);
    } else {
      const decode = jwtDecode(token);
      console.log(decode);
      getProfileStatus(decode.UserId).then((res) => {
        console.log(res);
        if (res.message == "Verified Profile") {
          const numDays = moment(endDate).diff(moment(startDate), "days");
          const bookinData = {
            carListId: carData.carListId,
            ownerId: carData.ownerId,
            rentPerDay: carData.price,
            tripFeePerDay: 0,
            deliveryFee: 0,
            tax: 0,
            totalPrice: carData.price * numDays,
            tripStartDate: startDate,
            tripEndDate: endDate,
            tripdays: numDays,
            tripPickUpLocation: carData?.pickUpLocation,
            customerNotes: "string",
            tripDeliveryLocation: "string",
            user_Id: "string",
            activeStatus: true,
          };
          carBooking(bookinData).then((res) => {
            console.log("res", res);
            if (res.success == true) {
              alert("Your request is sent to the owner of this car");
              navigate("/");
              setLoading(false);
            }
          });
        } else {
          alert("Your profile is not verified yet");
          setLoading(false);
        }
      });
    }
  };
  function convertToISO8601(dateString) {
    const dateObject = new Date(dateString);
    const iso8601String = dateObject.toISOString().slice(0, 16);
    return iso8601String;
  }

  const reportCar = () => {
    if (reportListingReason == "") {
      alert("Select reson to report");
    } else if (reportListingNotes == "") {
      alert("Write notes");
    } else {
      const token = localStorage.getItem("token");
      console.log("token", token);
      if (token == null) {
        alert("Please Login");
      } else {
        const decoded = jwtDecode(token);
        const obj = {
          userId: decoded.UserId,
          carListId: carData.carListId,
          reason: reportListingReason,
          notes: reportListingNotes,
        };
        reportListings(obj).then((res) => {
          console.log(res);
          if (res.success == true) {
            alert("Success");
            toggle();
          }
        });
      }
    }
  };
  console.log("car", carImage);
  return (
    <Helmet title="Car Booking">
      <section className="car__booking">
        <Container>
          <Row>
            {carImage.length > 0 ? (
              <Col lg="6">
                <ImageSlider images={carImage} />
              </Col>
            ) : null}
            <Col lg="4">
              <div className="booking__car__info">
                <h2> {carData.brandName + " " + carData.carName} </h2>
                <h3> {carData.price + "USD Per day"} </h3>
                <p className="section__description">{carData.description}</p>
              </div>
              <div>
                <h6 style={{ marginTop: 10 }}>Trip Dates:</h6>
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <p
                      style={{
                        marginRight: 10,
                        marginTop: 11,
                      }}
                    >
                      Trip Start Date: {moment(startDate).format("DD-MM-YYYY")}
                    </p>
                    <button
                      style={{ padding: 5 }}
                      onClick={() => setStartTimeModal(true)}
                    >
                      Change
                    </button>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <p
                      style={{
                        marginRight: 10,
                        marginTop: 11,
                      }}
                    >
                      Trip End Date : {moment(endDate).format("DD-MM-YYYY")}
                    </p>
                    <button
                      style={{ padding: 5 }}
                      onClick={() => setEndTimeModal(true)}
                    >
                      Change
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <h6 style={{ marginTop: 10 }}>Hosted by:</h6>
                <div>
                  <p>
                    {carData.userName} <br />
                    Joined on {moment(carData.joiningDate).format("DD-MM-YYYY")}
                  </p>
                </div>
              </div>
            </Col>
            <Col lg="2">
              <Button style={{ width: 140 }} onClick={carReserved}>
                Reserve
              </Button>
              <p
                style={{
                  display: "inline-block",
                  // backgroundColor: "#007bff",
                  color: "black",
                  padding: "10px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => setModal(true)}
              >
                🚩 Repor this Listing ?
              </p>
            </Col>
          </Row>

          <Col>
            {featuresList.length > 0 && (
              <div className="row">
                <div className="col-lg-12">
                  <h6 style={{ marginTop: 10 }}>Features:</h6>
                  <ul className="list-unstyled d-lg-flex flex-wrap">
                    {featuresList.map((feature, index) => (
                      <li
                        key={index}
                        className="w-20"
                        style={{
                          backgroundColor: "lightgray",
                          marginLeft: 10,
                          height: 50,
                          width: 150,
                          marginTop: 10,
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          borderRadius: 6,
                        }}
                      >
                        {formatFeatureName(feature)}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
            <h6 style={{ marginTop: 20, marginBottom: 20 }}>Map</h6>
            <div>
              <MyMapComponent
                isMarkerShown
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDf8vXaSoZYz_TQSWf1VmYrtw2TNOrEA_E&v=3.exp&libraries=geometry,drawing,places"
                // googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div className="map-container" />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            </div>
            <h6 style={{ marginTop: 20, marginBottom: 20 }}>
              Similar Listings
            </h6>
            <Row>{displayPage}</Row>
          </Col>
        </Container>
      </section>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          Why are you reporting this car
        </ModalHeader>
        <ModalBody>
          <div>This won't be share to car owner</div>
          <Form>
            <FormGroup className="booking__form d-inline-block me-4 mb-4">
              <select
                name=""
                id=""
                onChange={(event) => setReportListingReason(event.target.value)}
              >
                <option value="">Select...</option>
                <option
                  label={"Car location is wrong"}
                  value={"Car location is wrong"}
                ></option>
                <option
                  label={"Unauthorize use of images"}
                  value={"Unauthorize use of images"}
                ></option>
                <option
                  label={"Inaccurate car images"}
                  value={"Inaccurate car images"}
                ></option>
                <option
                  label={"Unauthorizze use of cars"}
                  value={"Unauthorizze use of cars"}
                ></option>
                <option
                  label={"Invalid Contact Details"}
                  value={"Invalid Contact Details"}
                ></option>
                <option label={"Others"} value={"Others"}></option>
              </select>
            </FormGroup>
            <FormGroup className="login__form d-flex align-items-center gap-4 mb-4">
              <input
                placeholder="Write text"
                onChange={(e) => setReportListingNotes(e.target.value)}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={reportCar}>
            Send
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={startTimemodal} toggle={toggleStartTime}>
        <ModalHeader toggle={toggleStartTime}>
          Change Trip Start Date
        </ModalHeader>
        <ModalBody>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div>
              <DateTimePicker
                label="Start Date and Time"
                // value={startDate}
                onChange={(newDate) => {
                  let date = moment(newDate)._i.$d;
                  setStartDate(date);
                  let endDate = moment(date).add(2, "day");
                  const iso8601Date = convertToISO8601(endDate);
                  console.log("iso", iso8601Date);
                  setEndDate(iso8601Date);
                }}
                disableOpenOnFocus={false}
                minDate={dayjs()}
                // onAccept={(newValue) => {
                //   const a = newValue;
                //   const IOSstringdate = convertMomentToiOSDateString(startDate);
                //   console.log("new", moment(newValue._i.$d).format("dddd"));

                //   setStartDate(IOSstringdate);
                // }}
                renderInput={(params) => <input {...params} />} // You can customize the input field here
              />
            </div>
          </LocalizationProvider>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={toggleStartTime}
            // onClick={() =>
            //   console.log("stratTime", moment(startDate).format("DD/MM/YYYY"))
            // }
          >
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={endTimeModal} toggle={toggleEndTime}>
        <ModalHeader toggle={toggleEndTime}>Change Trip End Date</ModalHeader>
        <ModalBody>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div>
              <DateTimePicker
                label="End Trip Date and Time"
                defaultValue={dayjs(endDate)}
                minDate={dayjs(startDate)}
                // value={new Date(endDate)}
                // onChange={(newDate) => setStartDate(newDate)}
                onChange={(newDate) => {
                  let date = moment(newDate)._i.$d;
                  const iso8601Date = convertToISO8601(date);
                  setEndDate(iso8601Date);
                }}
                disableOpenOnFocus={false}
                // onAccept={(newValue) => {
                //   const startDate =
                //     moment(newValue).format("DD/MM/YYYY hh:mm A");
                //   const IOSstringdate = convertMomentToiOSDateString(startDate);
                //   console.log("new", IOSstringdate);
                //   setStartDate(newValue);
                // }}
                renderInput={(params) => <input {...params} />} // You can customize the input field here
              />
            </div>
          </LocalizationProvider>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleEndTime}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
      {loading ? <FullScreenLoader /> : null}
    </Helmet>
  );
};
export default CarBookingView;
